import { render, staticRenderFns } from "./zjxsjlList.vue?vue&type=template&id=c453fe88"
import script from "./zjxsjlList.vue?vue&type=script&lang=js"
export * from "./zjxsjlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports